export const colors = {
  danger: '#d33043',
  success: '#349c50',
  warning: '#ed6c02',
  info: '#65626a',
};
